import HomeCard from "../../../UI/HomeCard";
import Skills from "./skills";

const SkillSection = () => {
  return (
    <HomeCard>
      <h2>Tech Stacks</h2>
      <Skills />
    </HomeCard>
  );
};
export default SkillSection;
